export default __webpack_public_path__ + "static/media/accountImage.ec807dec.svg";